import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    wrapper: {
      display: 'grid',
      gridTemplateColumns: '75% 25%',
      gridTemplateRows: 'auto 1fr',
      gridTemplateAreas: `
            "slider aside"
            "content content"
          `,
      [mediaQuery(BreakPoints.Small)]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto auto auto',
        gridTemplateAreas: `
          "slider"
          "aside"
          "content"
        `,
      },
    },
    slider: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s24,
      padding: Spacings.s24,
      gridArea: 'slider',
    },
    aside: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s24,
      padding: Spacings.s24,
      gridArea: 'aside',
    },
    content: {
      padding: Spacings.s24,
      gridArea: 'content',
    },
    skeleton: {
      borderRadius: CornerRadius.r8,
    },
    sliderImage: {
      objectFit: 'contain',
      maxWidth: '100%',
      height: 530,
    },
    description: {
      width: '100%',
      height: 70,
    },
    asideItem1: {
      height: 60,
    },
    asideItem2: {
      height: 80,
    },
    asideItem3: {
      height: 100,
    },
    asideItem4: {
      height: 100,
    },
    asideItem5: {
      height: 120,
    },
    navigation: {
      margin: [Spacings.s8, Spacings.s24],
      height: 40,
      width: '50%',
      [mediaQuery(BreakPoints.Small)]: {
        width: '100%',
      },
    },
  },
  {
    name: 'singlet-template-skeleton',
  },
);

export default useStyles;
